export default __webpack_public_path__ + "static/media/weightlosswithfamily_2@3x.c02e6b7c.jpg";